import { Modal, Select, Form } from "antd";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { ApiService, Control, Hazard } from "../../api";
import { debounce } from "lodash";

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  handleAddControl: (hazardId: number, control: Control) => void;
  hazardId: number;
}

const AddControlModal = ({
  visible,
  setVisible,
  handleAddControl,
  hazardId,
}: Props) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [controls, setControls] = useState<Hazard[]>([]);

  useEffect(() => {
    loadControls();
  }, [visible]);

  const loadControls = async () => {
    if (!hazardId) {
      return;
    }

    const result = await ApiService.apiAssessmentLastFiveControlsList(hazardId);
    setControls(result);
  };

  const handleSearchControls = async (value: string) => {
    const result = await ApiService.apiAssessmentGetControlsByQueryList(
      hazardId,
      value
    );
    // setHazards(result);
    setControls(result.slice(0, 10));
  };

  const handleSubmit = (values: any) => {
    const control = controls.find((x) => x.id === values.control);
    control && handleAddControl(hazardId, control);
    form.resetFields();
    setControls([]);
    setVisible(false);
  };

  return (
    <Modal
      onOk={() => form.submit()}
      onCancel={() => setVisible(false)}
      open={visible}
      title={t("Add control")}
    >
      <Form form={form} onFinish={handleSubmit}>
        <Form.Item
          name="control"
          label={t("Control")}
          rules={[
            {
              required: true,
              message: t("Please choose the control."),
            },
          ]}
        >
          <Select
            placeholder={t("Choose control..")}
            showSearch
            optionFilterProp="children"
            onSearch={debounce(handleSearchControls, 300)}
          >
            {controls.map((x) => (
              <Select.Option value={x.id}>{x.name}</Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddControlModal;
